import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CompaniaFarmaceuticaImportService } from 'src/app/services/entidades/compania-farmaceutica-import.service';
import { SignoPadronesService } from 'src/app/services/entidades/signo-padrones.service';
import Swal from 'sweetalert2';

@Component({ selector: 'app-compania-farmaceutica-import', templateUrl: './compania-farmaceutica-import.component.html', styleUrls: ['./compania-farmaceutica-import.component.scss'] })
export class CompaniaFarmaceuticaImportComponent implements OnInit, OnDestroy {
  meta: any; job: any; report: any; busy = false; message = ''; error = '';
  file: File | null = null; filter = ''; page = 0; pageSize = 25;
  geoRunning = false; stopGeo = false; geoProgress = 0; destroyed = false;
  resolving = false; resolveStop = false; resolveProgress = 0; resolveTotal = 0;
  configured = false; provinceReviewed = false; locationsReviewed = false;
  names: string[] = []; regions: string[] = []; zonaItems: { key: string; zona: string; region: string }[] = []; zonaFilter = '';
  renames: { [name: string]: string } = {};
  config = { managerId: '', especialidadId: '', rubroIds: [] as string[], planIds: [] as string[] };
  commitProgress = { running: false, done: 0, total: 0, current: '', created: 0, skipped: 0, failed: 0, failedList: [] as { name: string; error: string }[] };
  constructor(private api: CompaniaFarmaceuticaImportService, private padronesService: SignoPadronesService, private cdr: ChangeDetectorRef) {}
  private advance(stepper: any) { this.cdr.detectChanges(); if (stepper) { stepper.next(); } }
  private withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Tiempo de espera agotado')), ms);
      promise.then(value => { clearTimeout(timer); resolve(value); }, error => { clearTimeout(timer); reject(error); });
    });
  }
  normalize(value: string) { return (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim(); }
  async ngOnInit() {
    await this.run(async () => {
      this.meta = await this.api.request('GET', '/metadata');
      this.meta.specialties.sort((a, b) => a.concepto.localeCompare(b.concepto, 'es', { sensitivity: 'base' }));
      const farm = this.meta.specialties.find(s => this.normalize(s.concepto).includes('FARMACIA'));
      if (farm) { this.config.especialidadId = farm._id; }
      const saved = sessionStorage.getItem('compania-farmaceutica-import-id');
      if (saved) { try { this.setJob(await this.api.request('GET', '/' + saved)); this.report = await this.api.request('GET', '/' + saved + '/preview'); if (!this.report.errors.length) { this.configured = this.provinceReviewed = this.locationsReviewed = true; } } catch { sessionStorage.removeItem('compania-farmaceutica-import-id'); } }
    });
  }
  ngOnDestroy() { this.stopGeo = true; this.destroyed = true; }
  async run(action: () => Promise<void>) {
    this.busy = true; this.error = '';
    try { await action(); } catch (e) { const err = e.error; this.error = (err && (err.message || err.response && err.response.message)) || e.message || 'No se pudo completar la operación.'; if (Array.isArray(this.error)) { this.error = (this.error as any).join('\n'); } }
    finally { this.busy = false; }
  }
  choose(event: any) { this.file = event.target.files[0] || null; }
  setJob(job: any) {
    this.job = job; this.config = job.config; sessionStorage.setItem('compania-farmaceutica-import-id', job._id);
    this.refreshLists();
  }
  refreshLists() {
    this.names = Array.from(new Set<string>(this.job.rows.map(r => r.name))).sort();
    this.regions = Array.from(new Set<string>(this.job.rows.map(r => r.region))).sort();
    const items = new Map<string, { key: string; zona: string; region: string }>();
    this.job.rows.forEach((r: any) => {
      const key = this.zonaKey(r.zona, r.region);
      if (!items.has(key)) { items.set(key, { key, zona: r.zona, region: r.region }); }
      if (!this.job.localityMap[key]) {
        this.job.localityMap[key] = this.job.localityMap[r.zona] ? Object.assign({}, this.job.localityMap[r.zona]) : { id: '', zoneId: '', newName: r.zona, newZoneName: '', provinceId: '', source: '' };
      }
    });
    this.zonaItems = Array.from(items.values());
    this.names.forEach(name => { if (!this.renames[name]) { this.renames[name] = name; } });
  }
  zonaKey(zona: string, region: string) { return zona + '|' + region; }
  async rename(name: string) {
    const target = (this.renames[name] || '').trim(); if (!target || target === name) { return; }
    this.job.rows.filter(r => r.name === name).forEach(r => r.name = target);
    this.refreshLists(); this.invalidateReview();
  }
  invalidateReview() { this.configured = false; this.provinceReviewed = false; this.locationsReviewed = false; this.report = null; }
  invalidateLocations() { this.provinceReviewed = false; this.locationsReviewed = false; this.report = null; }
  countName(name: string) { return this.job.rows.filter(r => r.name === name).length; }
  isRegionResolved(region: string) { return !!this.job.regionMap[region]; }
  get sortedRegions() { return [...this.regions].sort((a, b) => Number(this.isRegionResolved(a)) - Number(this.isRegionResolved(b)) || a.localeCompare(b, 'es', { sensitivity: 'base' })); }
  get pendingRegionsCount() { return this.regions.filter(r => !this.isRegionResolved(r)).length; }
  provinceNameForRegion(region: string) { const pid = this.job.regionMap[region]; const p = this.meta && this.meta.provinces.find((x: any) => x._id === pid); return p ? p.nombre : ''; }
  jobProvinceForZona(key: string) { const m = this.job.localityMap[key]; if (m && m.provinceId) { return m.provinceId; } const item = this.zonaItems.find(it => it.key === key); return item ? (this.job.regionMap[item.region] || '') : ''; }
  provinceNameForZona(key: string) { const pid = this.jobProvinceForZona(key); const p = this.meta && this.meta.provinces.find((x: any) => x._id === pid); return p ? p.nombre : ''; }
  isZonaResolved(key: string) {
    const m = this.job.localityMap[key]; if (!m) { return false; }
    const locOk = !!m.id && (m.id !== 'new' || (m.newName || '').trim());
    const zoneOk = !!m.zoneId && (m.zoneId !== 'new' || (m.newZoneName || '').trim());
    return !!locOk && !!zoneOk;
  }
  zonaRank(key: string) {
    const m = this.job.localityMap[key];
    if (!this.isZonaResolved(key)) { return 0; }
    return (m && (m.source === 'catalog' || m.source === 'geocoder')) ? 2 : 1;
  }
  get filteredZonaItems() {
    const q = this.normalize(this.zonaFilter);
    const list = this.zonaItems.filter(it => !q || this.normalize(it.zona + ' ' + it.region).includes(q));
    return [...list].sort((a, b) => this.zonaRank(a.key) - this.zonaRank(b.key) || a.zona.localeCompare(b.zona, 'es', { sensitivity: 'base' }));
  }
  get pendingZonasCount() { return this.zonaItems.filter(it => !this.isZonaResolved(it.key)).length; }
  get zonasAResolver() { return this.zonaItems.filter(it => { const m = this.job.localityMap[it.key]; return !m || m.source !== 'catalog'; }); }
  sourceLabel(key: string) {
    const m = this.job.localityMap[key]; if (!m || !m.id) { return 'Pendiente'; }
    if (m.source === 'catalog') { return 'Catálogo'; }
    if (m.source === 'geocoder') { return 'Internet'; }
    if (m.source === 'manual') { return 'Manual'; }
    return m.id === 'new' ? 'Nueva (sin verificar)' : 'Nueva';
  }
  private errorTarget(error: string): { zona: string; region: string } {
    const m = String(error).match(/sin resolver:\s*(.+?)\s*\(región\s*(.+?)\s*·/i);
    if (m) { return { zona: m[1].trim(), region: m[2].trim() }; }
    const m2 = String(error).match(/sin resolver(?: en la provincia)?:\s*(.+?)(?:\s*\(.*\))?$/i);
    return { zona: m2 ? m2[1].trim() : '', region: '' };
  }
  isLocalityError(error: string) { return /sin resolver/i.test(String(error)); }
  verError(error: string) { this.zonaFilter = this.errorTarget(error).zona; }
  resolverError(error: string) {
    const t = this.errorTarget(error);
    const it = this.zonaItems.find(x => x.zona === t.zona && (!t.region || x.region === t.region)) || this.zonaItems.find(x => x.zona === t.zona);
    if (it) { this.resolverZona(it.key); }
  }
  async reloadJob() { await this.run(async () => { this.setJob(await this.api.request('GET', '/' + this.job._id)); this.report = await this.api.request('GET', '/' + this.job._id + '/preview'); }); }
  get validConfig() { return this.config.managerId && this.config.especialidadId && this.config.planIds.length && this.config.rubroIds.length; }
  localitiesForZona(key: string) {
    if (!this.meta || !this.job) { return []; }
    const pid = this.jobProvinceForZona(key);
    return pid ? this.meta.localities.filter((l: any) => l.provincia && l.provincia._id === pid) : this.meta.localities;
  }
  localityChanged(key: string) { const mapping = this.job.localityMap[key]; mapping.source = 'manual'; const loc = this.meta.localities.find((l: any) => l._id === mapping.id); const zid = loc && loc.zona; if (zid && this.meta.zones.some((z: any) => z._id === zid)) { mapping.zoneId = zid; } }
  async resolverZona(key: string) {
    try { this.applyResolution(key, await this.api.resolveLocality(this.job._id, key)); } catch { /* conservar el estado */ }
  }
  applyResolution(key: string, res: any) {
    const m = this.job.localityMap[key]; if (!m || !res) { return; }
    if (res.provinceId) { m.provinceId = res.provinceId; }
    if (res.localidadId) { m.id = res.localidadId; } else { m.id = 'new'; m.newName = res.name || m.newName; }
    m.source = res.source || 'fallback';
    if (res.zoneId) { m.zoneId = res.zoneId; }
  }
  async resolverPendientes() {
    if (this.resolving) { return; }
    this.resolving = true; this.resolveStop = false; this.resolveProgress = 0;
    const list = this.zonasAResolver.map(it => it.key);
    this.resolveTotal = list.length;
    try {
      for (const key of list) {
        if (this.resolveStop) { break; }
        await this.resolverZona(key);
        this.resolveProgress++;
        if (this.resolveStop) { break; }
        await new Promise(resolve => setTimeout(resolve, 1200));
      }
    } finally { this.resolving = false; this.locationsReviewed = false; this.report = null; }
  }
  get filteredRows() { if (!this.job) { return []; } const q = this.normalize(this.filter); return this.job.rows.filter(r => !q || this.normalize(r.name + ' ' + r.zona + ' ' + r.region + ' ' + r.row).includes(q)); }
  get visibleRows() { return this.filteredRows.slice(this.page * this.pageSize, (this.page + 1) * this.pageSize); }
  get totalPages() { return Math.max(1, Math.ceil(this.filteredRows.length / this.pageSize)); }
  get results() { const map = new Map(); if (this.job) { this.job.results.forEach(r => map.set(r.key, r)); } return Array.from(map.values()); }
  get resultCounts() {
    const results = this.job && this.job.results ? this.job.results : [];
    return {
      created: results.filter(r => r.status === 'Creado').length,
      skipped: results.filter(r => r.status === 'Existente omitido').length,
      failed: results.filter(r => r.status === 'Error').length,
    };
  }
  label(id: string) { const s = this.meta.specialties.find(x => x._id === id); return s ? s.concepto : id; }
  async analyze() {
    if (!this.file || !this.validConfig) { return; }
    await this.run(async () => { this.setJob(await this.api.analyze(this.file, this.config)); this.report = null; this.configured = false; this.provinceReviewed = false; this.locationsReviewed = false; this.message = 'Archivo analizado. Revisá las filas y el mapeo de provincias y localidades.'; });
  }
  async save() { this.refreshLists(); this.job.config = this.config; this.setJob(await this.api.request('PUT', '/' + this.job._id, this.job)); this.report = null; }
  async nextConfig(stepper: any) { await this.run(async () => { await this.save(); this.configured = true; this.advance(stepper); }); }
  async nextProvince(stepper: any) { await this.run(async () => { await this.save(); this.provinceReviewed = true; this.advance(stepper); }); }
  async preview(stepper?: any) { await this.run(async () => { await this.save(); this.report = await this.api.request('GET', '/' + this.job._id + '/preview');       if (!this.report.errors.length) {
        this.provinceReviewed = true;
        this.locationsReviewed = true;
        this.advance(stepper);
      } }); }
  async geolocate() {
    this.geoRunning = true; this.stopGeo = false; this.geoProgress = 0; this.error = '';
    try {
      for (const c of this.report.centers) {
        if (this.stopGeo) { break; }
        if (!c.coordinates && !c.exists) {
          try { c.coordinates = await this.withTimeout(this.api.request('POST', '/' + this.job._id + '/geolocate', { key: c.key }), 15000); }
          catch { this.error = 'Algunas direcciones no pudieron geolocalizarse. Se conservarán sin coordenadas.'; }
          if (this.stopGeo) { break; }
          await new Promise(resolve => setTimeout(resolve, 1500));
        }
        this.geoProgress++;
      }
    } finally { this.geoRunning = false; }
    await this.refreshDraft();
  }
  async refreshDraft() {
    if (this.destroyed || !this.job) { return; }
    try { this.setJob(await this.api.request('GET', '/' + this.job._id)); this.report = await this.api.request('GET', '/' + this.job._id + '/preview'); } catch { /* conservar el estado actual */ }
  }
  async commit() {
    if (!this.report || this.job.status === 'completed') { return; }
    if (this.report.errors.length) {
      await Swal.fire({ title: 'Hay errores por resolver', html: this.report.errors.map(e => '• ' + e).join('<br>'), icon: 'error', confirmButtonText: 'Entendido' });
      return;
    }
    const centers = (this.report.centers || []) as any[];
    const confirmation = await Swal.fire({ title: '¿Crear los centros revisados?', text: `Se crearán ${centers.length} centros de a uno. Los existentes se omiten; si uno falla, se continúa con el siguiente.`, icon: 'question', showCancelButton: true, confirmButtonText: 'Confirmar importación', cancelButtonText: 'Volver' });
    if (!confirmation.isConfirmed) { return; }
    this.commitProgress = { running: true, done: 0, total: centers.length, current: '', created: 0, skipped: 0, failed: 0, failedList: [] };
    for (const c of centers) {
      this.commitProgress.current = c.name;
      try {
        const r = await this.api.commitOne(this.job._id, c.key);
        if (r && r.status === 'Creado') { this.commitProgress.created++; }
        else if (r && r.status === 'Existente omitido') { this.commitProgress.skipped++; }
        else { this.commitProgress.failed++; this.commitProgress.failedList.push({ name: c.name, error: (r && r.error) || 'Error desconocido' }); }
      } catch (e: any) {
        this.commitProgress.failed++;
        this.commitProgress.failedList.push({ name: c.name, error: (e && e.message) ? e.message : 'Error de comunicación con el servidor' });
      }
      this.commitProgress.done++;
      this.cdr.detectChanges();
    }
    this.commitProgress.running = false;
    let status = 'review';
    try { this.setJob(await this.api.finalize(this.job._id)); status = this.job.status; } catch { /* conservar */ }
    this.message = status === 'completed' ? 'Importación finalizada.' : 'Hay errores. Podés corregir y reintentar sin duplicar centros.';
    const p = this.commitProgress;
    const failedHtml = p.failedList.length
      ? `<div style="max-height:220px; overflow:auto; text-align:left; margin-top:8px;">${p.failedList.map(f => `<div style="border-bottom:1px solid #eee; padding:4px 0;"><b>${f.name}</b><br><span style="color:#d10505; font-size:0.85em;">${f.error}</span></div>`).join('')}</div>`
      : '';
    await Swal.fire({
      title: p.failed ? 'Importación con errores' : 'Importación finalizada',
      html: `<div style="text-align:left"><p><b>Centros creados:</b> ${p.created}</p><p><b>Centros omitidos (ya existían):</b> ${p.skipped}</p><p><b>Con errores:</b> ${p.failed}</p>${failedHtml}</div>`,
      icon: p.failed > 0 ? 'warning' : 'success',
      confirmButtonText: 'Entendido'
    });
    await this.saveHistory().catch(err => console.error('Error guardando historial Compañía Farmacéutica:', err));
  }

  async saveHistory() {
    const results = this.job && this.job.results ? this.job.results : [];
    const centers = this.report && this.report.centers ? this.report.centers : [];
    const created = results.filter(r => r.status === 'Creado');
    const skipped = results.filter(r => r.status === 'Existente omitido');
    const failed = results.filter(r => r.status === 'Error');
    const geolocated = centers.filter(c => c.coordinates).length;
    const manager = this.meta && this.meta.managers ? this.meta.managers.find(m => m._id === this.config.managerId) : null;

    const historyRecord = {
      tipo: 'COMPANIA_FARMACEUTICA',
      gerenciadoraName: manager ? manager.nombre : 'Compañía Farmacéutica',
      filename: this.job.fileName || 'sin_nombre.xlsx',
      totalRecords: this.job.rows ? this.job.rows.length : 0,
      totalCenters: centers.length,
      geolocatedCenters: geolocated,
      unmatchedCenters: centers.length - geolocated,
      createdCount: created.length,
      skippedCount: skipped.length,
      failedCount: failed.length,
      detallesCreados: created.map(r => r.name),
      detallesFallidos: failed.map(r => ({ nombre: r.name, domicilio: r.locality, error: r.error })),
    };

    await this.padronesService.saveImportHistory(historyRecord);
  }
  newImport() { sessionStorage.removeItem('compania-farmaceutica-import-id'); this.job = null; this.report = null; this.file = null; this.configured = this.provinceReviewed = this.locationsReviewed = false; }
  downloadResults() { const blob = new Blob([JSON.stringify({ archivo: this.job.fileName, resultados: this.results, excluidas: this.job.rows.filter(r => r.excluded).map(r => r.row) }, null, 2)], { type: 'application/json' }); const url = URL.createObjectURL(blob); const a = document.createElement('a'); a.href = url; a.download = 'resultado-compania-farmaceutica.json'; a.click(); URL.revokeObjectURL(url); }
}
